import React from "react";

import { FormattedMessage as Message } from "react-intl";

import Layout from "../../components/Layout/Layout";
import ProductCard from "../../components/ProductCard/ProductCard";
import { appRoutes } from "../../resources/routes";

import image_1 from "../../assets/images/v2/microplastic/microplastic-main-1.png";
import image_2 from "../../assets/images/v2/microplastic/microplastic-main-2.png";
import automation_image_1 from "../../assets/images/v2/automation/automation-main-1.png";
import automation_image_2 from "../../assets/images/v2/automation/automation-main-2.png";
import varka_1 from "../../assets/images/v2/varka/varka-main-1.png";
import varka_2 from "../../assets/images/v2/varka/varka-main-2.png";

const products = [
    {
        key: "microplastic",
        titleId: "microplastic.title",
        descriptionIds: ["microplastic.description1"],
        images: [{ src: image_1 }, { src: image_2 }],
        ctas: [{ to: appRoutes.microplastic, labelId: "commons.more" }],
    },
    {
        key: "sugar-cooking",
        titleId: "sugar-cooking.title",
        descriptionIds: ["sugar-cooking.description1"],
        images: [{ src: automation_image_1 }, { src: automation_image_2 }],
        ctas: [
            { to: appRoutes.sugarCookingVideo, labelId: "commons.video", variant: "video" },
            { to: appRoutes.sugarCooking, labelId: "commons.more" },
        ],
    },
    {
        key: "massecuite",
        titleId: "massecuite.title",
        descriptionIds: ["massecuite.description1"],
        images: [{ src: varka_1 }, { src: varka_2 }],
        ctas: [{ to: appRoutes.massecuite, labelId: "commons.more" }],
    },
    {
        key: "color-analyzer",
        titleId: "color-analyzer.title",
        descriptionIds: [
            "color-analyzer.description1",
            "color-analyzer.description2",
            "color-analyzer.description3",
            "color-analyzer.description4",
            "color-analyzer.description5",
            "color-analyzer.description6",
        ],
        images: [],
        ctas: [{ to: appRoutes.colorAnalyzer, labelId: "commons.more" }],
    },
];

const HomePage = ({ setLocale }) => {
    return (
        <Layout setLocale={setLocale}>
            <div className="home-hero">
                <div className="home-hero__content">
                    <span className="home-hero__title">
                        <Message id="home.text-block.title" />
                    </span>
                    <span className="home-hero__subtitle">
                        <Message id="home.text-block.subtitle" />
                    </span>
                    <span className="home-hero__text">
                        <Message id="home.text-block.text" />
                    </span>
                </div>
            </div>

            <div className="home-content">
                <div className="home-products-grid">
                    {products.map((product) => (
                        <ProductCard key={product.key} {...product} />
                    ))}
                </div>
            </div>
        </Layout>
    )
};

export default HomePage
